import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    switch: {
        "&.MuiSwitch-root": {
            "& .MuiSwitch-thumb": {
                background: `${theme.palette.border.main} !important`,
            },
            "& .Mui-checked": {
                "& .MuiSwitch-thumb": {
                    background: `${theme.palette.info.light} !important`,
                },
            },
            "& .Mui-checked+": {
                "& .MuiSwitch-track": {
                    background: `${theme.palette.info.lighter} !important`,
                },
            },
            "& .MuiSwitch-switchBase.Mui-disabled": {
                opacity: 0.6,
                "& .MuiSwitch-thumb": {
                    background: `${theme.palette.disabled.thumb} !important`,
                },
                "& + .MuiSwitch-track": {
                    backgroundColor: `${theme.palette.disabled.track} !important`,
                    opacity: 0.6,
                },
            },
        },
    },
}));
